import React from 'react';
import './InventarioToolbar.css';

function InventarioToolbar({
    searchValue = '',
    onSearchChange,
    onSearch,
    filterStatus = '',
    onFilterStatusChange,
    onNovoHardware,
    showNovoButton = true
}) {
    const handleSearchSubmit = (e) => {
        e.preventDefault();
        if (typeof onSearch === 'function') onSearch();
    };

    return (
        <div className="inventario-toolbar">
            <h1 className="inventario-toolbar__title">Inventário</h1>
            <div className="inventario-toolbar__actions">
                <form className="inventario-toolbar__search" onSubmit={handleSearchSubmit}>
                    <input
                        type="text"
                        className="form-control form-control-sm inventario-toolbar__search-input"
                        placeholder="Pesquisar por série, patrimônio, descrição..."
                        value={searchValue}
                        onChange={(e) => onSearchChange && onSearchChange(e.target.value)}
                        aria-label="Pesquisar"
                    />
                    <button type="submit" className="btn btn-secondary btn-sm" title="Pesquisar">
                        <i className="fas fa-search" />
                    </button>
                </form>
                <select
                    className="form-select form-select-sm inventario-toolbar__filter"
                    value={filterStatus}
                    onChange={(e) => onFilterStatusChange && onFilterStatusChange(e.target.value)}
                    aria-label="Filtrar por status"
                >
                    <option value="">Todos os status</option>
                    <option value="inStock">Em estoque</option>
                    <option value="assigned">Atribuído</option>
                    <option value="inMaintenance">Em manutenção</option>
                    <option value="retired">Baixado</option>
                </select>
                {showNovoButton && (
                    <button
                        type="button"
                        className="btn btn-primary btn-sm inventario-toolbar__btn-novo"
                        onClick={onNovoHardware}
                    >
                        <i className="fas fa-plus" /> Novo hardware
                    </button>
                )}
            </div>
        </div>
    );
}

export default InventarioToolbar;
